<template>
  <div class="checkuser">
    <Header propsTitle="check-user" head-title="보건의료 전문가 회원가입" @clickBack="$emit('clickBack')" />
    <div class="container height-fix">
      <div>
        <h6 class="step-sub-title">귀하는 한국의 보건의료전문가입니까?</h6>
        <p class="step-sub-contents">
          본 웹사이트는 대한민국의 보건의료 전문가용 의약품 정보
          제공 웹사이트입니다. 보건의료전문가 본인이 아닐 경우 회원
          가입 및 서비스 이용이 불가합니다. 회원가입 신청 또는
          회원정보 변경 시 허위내용을 기재하거나 타인의 명의를
          도용할 경우 해당 정보는 삭제되며, 관계법령에 따라 처벌을
          받을 수 있습니다.
        </p>
      </div>
      <div class="bottom-btn">
        <v-btn color="mainColorDark" x-large depressed block class="mb-3 btn-text-white" @click="$emit('clickNext')">네, 보건의료 전문가 입니다</v-btn>
        <v-btn color="mainColorLight" x-large depressed block @click="$emit('clickBack')"> 아니오, 보건의료 전문가가 아닙니다.</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../commonComp/WS-Header.vue";

export default {
  components: { Header },
  methods: {},
};
</script>

